import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import * as React from "react";
import MenuBar from "components/mnl/global/menuBar";
import { theme } from "components/mnl/global/theme";
import V2sessionTimeout from "components/mnl/global/v2SessionTimeout";
import TableLayout from "views/mnl/layout/tableLayout";
import GetAllLabtestRequirementTemplate from "components/mnl/admin/labtestRequirementTemplate/getAllLabtestRequirementTemplate";

const LabTestRequirementTemplatePage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <MenuBar pageName={"Requirement Template"} />
        <TableLayout>
          <GetAllLabtestRequirementTemplate />
        </TableLayout>
      </Box>
      <V2sessionTimeout />
    </ThemeProvider>
  );
};

export default LabTestRequirementTemplatePage;
